import { render, staticRenderFns } from "./or.vue?vue&type=template&id=f5b30a0a&"
import script from "./or.vue?vue&type=script&lang=js&"
export * from "./or.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports